import { createContext, useContext, useEffect, useState, useCallback } from "react";
import sellerApi from "@/lib/sellerApi";

const SellerAuthContext = createContext(null);

export function SellerAuthProvider({ children }) {
  const [seller, setSeller] = useState(null); // null = checking, false = logged out
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("ne_seller_token");
    if (!token) {
      setSeller(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await sellerApi.get("/seller/me");
      setSeller(data);
    } catch {
      localStorage.removeItem("ne_seller_token");
      setSeller(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (payload) => {
    const { data } = await sellerApi.post("/seller/login", payload);
    localStorage.setItem("ne_seller_token", data.token);
    setSeller(data.seller);
    return data.seller;
  };

  const logout = () => {
    localStorage.removeItem("ne_seller_token");
    setSeller(false);
  };

  return (
    <SellerAuthContext.Provider value={{ seller, loading, login, logout, refresh: loadMe }}>
      {children}
    </SellerAuthContext.Provider>
  );
}

export const useSellerAuth = () => useContext(SellerAuthContext);
